import React from "react";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import I18nText from "../../../elements/I18nText";

const TableColumnCheckbox = ({ name, checked, onUpdate, disabled = false }) => {
  const label = (
    <I18nText>{`devices.list.table.header.${
      name === "username" ? "user" : name
    }`}</I18nText>
  );

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          color="primary"
          onChange={onUpdate}
          value={checked}
          disabled={disabled}
        />
      }
      label={label}
      disabled={disabled}
    />
  );
};

export default TableColumnCheckbox;
